import ReactGA from 'react-ga4';

ReactGA.initialize('G-DSVBT29NGR');

export default ReactGA;